import { breakpoints } from './breakpoints';
import type { MediaQueriesLegacy } from './types';

const { lg, md, sm, xl, xs } = breakpoints;

const mediaQueriesLegacy: MediaQueriesLegacy = {
  xs: `@media screen and (min-width: ${xs})`,
  sm: `@media screen and (min-width: ${sm})`,
  md: `@media screen and (min-width: ${md})`,
  lg: `@media screen and (min-width: ${lg})`,
  xl: `@media screen and (min-width: ${xl})`,
};

export { mediaQueriesLegacy };
